import React from 'react'
import Input, { InputLabel } from 'material-ui/Input'
import NumberFormat from 'react-number-format'
import { FormControl, FormHelperText } from 'material-ui/Form'

function NumberFormatCustom({ onChange, onBlur, ...props }) {
  return (
    <NumberFormat
      {...props}
      thousandSeparator
      onValueChange={({ floatValue }) => onChange(floatValue)}
    />
  )
}

const Amount = ({ input, meta, label, ...props }) => (
  <FormControl error={meta.error && meta.touched}>
    <InputLabel>{label}</InputLabel>
    <Input
      inputComponent={NumberFormatCustom}
      value={input.value}
      inputProps={{
        'aria-label': label,
        ...input,
      }}
    />
    {meta.error &&
    meta.touched && <FormHelperText error>{meta.error}</FormHelperText>}
  </FormControl>
)

export default Amount



// WEBPACK FOOTER //
// ./src/components/fields/Amount.js